import { config, debug, i18n, inject, LoginAPI, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { PdfViewer } from "components/common/PdfViewer";
import authStore from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { safeWindowOpen } from "util/helpers";
import { BSPOptionsDetails } from "./BSPOptionsDetails";
import { BSPOptionsOverview } from "./BSPOptionsOverview";
import { BSPOptionsPayoutRedirect } from "./BSPOptionsPayoutRedirect";
import { BSPOptionsPayoutSummary } from "./BSPOptionsPayoutSummary";
import { BSPOptionsRoutes } from "./BSPOptionsRoutes";
import { BSPOptionsSigning } from "./BSPOptionsSigning";
import { BSPOptionsStore } from "./BSPOptionsStore";
import { BSPOptionsSuccess } from "./BSPOptionsSuccess";
import { BSPOptionsSummary } from "./BSPOptionsSummary";


type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class BSPOptionsContainer extends React.Component<IProps> {
    store: BSPOptionsStore;

    constructor(props: any) {
        super(props);
        this.store = new BSPOptionsStore();
    }

    async componentDidMount() {
        try {
            if (!history.location.pathname.endsWith(BSPOptionsRoutes.PAYOUT)) {
                pushRoute(BSPOptionsRoutes.ROOT);
            }

            georgeWebHeaderStore.configure({
                title: ui.__("bspOptions.document.title"),
                backBehaviour: "tokenExchange"
            });

            if (!authStore.authorized) {
                safeWindowOpen(LoginAPI.getLoginUrl("C02345N6", window.location.href));
            } else {
                await this.store.loadData();
            }

        } catch (error) {
            debug.log("### BSPOptionsContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("bspOptions.document.title");
        return (
            <div>
                <Route exact path={BSPOptionsRoutes.ROOT} component={this.withStore(BSPOptionsOverview)} />
                <Route path={BSPOptionsRoutes.PAYOUT} component={this.withStore(BSPOptionsPayoutRedirect)} />
                <Route path={BSPOptionsRoutes.DETAILS} component={this.withStore(BSPOptionsDetails)} />
                <Route path={BSPOptionsRoutes.SUMMARY} component={this.store.selectedPayout ? this.withStore(BSPOptionsPayoutSummary) : this.withStore(BSPOptionsSummary)} />
                <Route path={BSPOptionsRoutes.SIGNING} component={this.withStore(BSPOptionsSigning)} />
                <Route path={BSPOptionsRoutes.SUCCESS} component={this.withStore(BSPOptionsSuccess)} />
                <Route path={BSPOptionsRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsContainer.tsx